export default __webpack_public_path__ + "static/media/feature_5.95ce340c.png";